var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticStyle:{"width":"130px!important"},attrs:{"src":"/img/wordmark.png","tag":"ArtistHub Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }